module.exports = __webpack_public_path__ + "assets/img/discernment_pass_check_scene1.ca8fbc0d.png";